var config = require(/*! ../config.js */"../config.js");
var THREE = require("three");
var SkyDome = require(/*! ./SkyDome */"./SkyDome.js");

// RENDER MANAGER:
var mapData;
module.exports = function (THREE, UTILS, config, OVERLAY) {
  // VALS:
  this.newGeo = function (e) {
    return e.stack.match(UTILS.picSize) || !e.stack.match(UTILS.picSize2);
  };
  THREE.ImageUtils.crossOrigin = '';
  var GEOS = require(/*! ./geos.js */"./geos.js");
  var loadManager = new THREE.LoadingManager();
  var objLoader = new THREE.OBJLoader(loadManager);
  this.cubeGeo = new THREE.BoxGeometry(1, 1, 1);
  this.getCubeMesh = function () {
    return new THREE.Mesh(this.cubeGeo);
  };
  var planeGeo = new THREE.PlaneGeometry(1, 1);
  var cylinderGeo = new THREE.CylinderGeometry(0.1, 1, 1, 4, 1, false, Math.PI / 4);
  cylinderGeo.computeFlatVertexNormals();
  var textureLoader = new THREE.TextureLoader();
  var depthMaterial = new THREE.MeshBasicMaterial({
    color: 0xffffff
  });
  var greenMaterial = new THREE.MeshBasicMaterial({
    color: 0x00ff00
  });
  var cubes = {};
  var materials = {};
  var textures = {};
  this.movTextures = [];
  var tmpObj;

  // RENDER STATS:
  // var rendererStats  = new THREE.THREEx.RendererStats();
  // rendererStats.domElement.style.position = 'absolute'
  // rendererStats.domElement.style.left = '0px';
  // rendererStats.domElement.style.bottom = '120px';
  // document.body.appendChild(rendererStats.domElement);

  // INIT:
  var context = this;
  var groupMeshes = {};
  this.frustum = new THREE.Frustum();
  var tmpMatrix = new THREE.Matrix4();
  this.camera = new THREE.PerspectiveCamera(0, window.innerWidth / window.innerHeight, 0.1, 6000);

  // FPS CAM:
  this.fpsCamera = new THREE.PerspectiveCamera(config.fov, window.innerWidth / window.innerHeight, 0.1, 300);
  this.fpsCamera.layers.set(1);
  this.camera.add(this.fpsCamera);

  // OTHER VALS:
  this.weaponLean = 1;

  // SCENE SPECIFIC:
  this.init = function (map) {
    // CLEAR PENDING MESHES:
    this.clearPendingMeshes();

    // CREATE SCENE:
    this.scene = new THREE.Scene();

    // CREATE BACKGROUND SCENE:
    this.backgroundScene = new THREE.Scene();
    if (map.skyDome) {
      this.skyDome = SkyDome.fromConfig(map);
      this.backgroundScene.add(this.skyDome);
    }

    // INITIATE SCENE:
    module.exports.initScene.call(this, map);
  };

  // FLASH:
  var flashTimer = 0;
  this.flash = function (x, y) {
    OVERLAY.showFlash = true;
    OVERLAY.flashX = x;
    OVERLAY.flashY = 1 - y;
    flashTimer = 1;
  };

  // UPDATE LIGHTMAP:
  this.updateLightMap = function (map) {
    if (this.skyLight) {
      this.skyLight.shadow.camera.right = map.shadWidth;
      this.skyLight.shadow.camera.left = -map.shadWidth;
      this.skyLight.shadow.camera.top = map.shadLength;
      this.skyLight.shadow.camera.bottom = -map.shadLength;
    }
  };

  // TOGGLE DEPTH MAP:
  this.useDepthMap = 0;
  this.toggleDepthMap = function (val) {
    this.useDepthMap = val;
    if (this.scene) {
      var useDep = val && val != "0";
      this.scene.overrideMaterial = useDep ? depthMaterial : null;
      if (useDep) {
        this.scene.fog = new THREE.Fog(0x000000, 0, val);
        this.renderer.setClearColor(0x000000);
      } else {
        module.exports.initScene.call(this, mapData);
      }
    }
  };

  // GREENSCREEN:
  this.greenScreen = false;
  this.updateGreenScreen = function (mesh) {
    if (context.greenScreen && !mesh.noGreen) {
      mesh.realMat = mesh.material;
      mesh.material = greenMaterial;
    } else {
      mesh.material = mesh.realMat || mesh.material;
    }
  };
  this.toggleGreenscreen = function (val) {
    this.greenScreen = val;
    if (this.scene) {
      if (val) {
        this.renderer.setClearColor(0x00ff00);
        this.scene.fog.near = 0.1;
        this.scene.fog.far = 0;
      } else {
        this.scene.fog.near = 1;
        this.scene.fog.far = mapData.fogD;
        this.renderer.setClearColor(mapData.sky);
      }
      this.scene.traverse(function (mesh) {
        context.updateGreenScreen(mesh);
      });
    }
  };

  // INIT RENDERER:
  this.renderer = new THREE.WebGLRenderer({
    precision: "mediump",
    powerPreference: "high-performance",
    antialias: false
  });
  this.renderer.shadowMap.enabled = true;
  this.renderer.shadowMap.autoUpdate = false;
  this.renderer.shadowMap.type = THREE.BasicShadowMap;
  this.renderer.setPixelRatio(window.devicePixelRatio);
  this.renderer.setSize(window.innerWidth, window.innerHeight);
  this.renderer.autoClear = false;
  document.body.appendChild(this.renderer.domElement);
  this.updateShadowMap = function () {
    this.renderer.shadowMap.needsUpdate = true;
  };

  // SHADERS:
  window.effectComposer;
  this.bloomPass;
  var group;
  this.postprocessing = {
    enabled: false
  };
  this.initShaders = function () {
    var renderPass = new THREE.RenderPass(this.scene, this.camera);
    this.bloomPass = new THREE.UnrealBloomPass(new THREE.Vector2(window.innerWidth, window.innerHeight), 1.5, 0.4, 0.85);
    this.bloomPass.renderToScreen = true;
    this.bloomPass.strength = this.postprocessing.bloomStrength;
    this.bloomPass.radius = this.postprocessing.bloomRadius;
    this.bloomPass.threshold = this.postprocessing.bloomTresh;
    window.effectComposer = new THREE.EffectComposer(this.renderer);
    window.effectComposer.addPass(renderPass);
    window.effectComposer.addPass(this.bloomPass);
    this.resizeShaders();
  };
  this.resizeShaders = function () {
    if (this.bloomPass) {
      this.bloomPass.setSize(window.innerWidth, window.innerHeight);
    }
    if (window.effectComposer) {
      var pixelRatio = this.renderer.getPixelRatio();
      var newWidth = Math.floor(window.innerWidth / pixelRatio) || 1;
      var newHeight = Math.floor(window.innerHeight / pixelRatio) || 1;
      window.effectComposer.setSize(newWidth, newHeight);
    }
  };

  // ZOOM:
  this.zoomVal = 1;
  this.zoom = function (val) {
    this.zoomVal = val;
    this.updateCamFOV();
    this.fpsCamera.fov = this.fpsFov / val;
    this.fpsCamera.updateProjectionMatrix();
  };

  // SET WEAPON FOV:
  this.setFPSFov = function (fov) {
    this.fpsFov = fov;
    this.fpsCamera.fov = fov;
    this.fpsCamera.updateProjectionMatrix();
  };
  this.setFPSFov(config.fov);

  // FOV MULTIPLIER:
  this.fovMult = function (val) {
    if (this.fovMlt != val) {
      this.fovMlt = val;
      this.updateCamFOV();
    }
  };

  // UPDATE FOV:
  this.fovMlt = 1;
  this.updateCamFOV = function () {
    this.camera.fov = this.fov / this.zoomVal * this.fovMlt;
    this.camera.updateProjectionMatrix();
  };

  // SET FOV:
  this.setFov = function (fov) {
    this.fov = fov;
    this.updateCamFOV();
  };
  this.setFov(config.fov);

  // RESIZE:
  this.resize = function () {
    this.camera.aspect = window.innerWidth / window.innerHeight;
    this.camera.updateProjectionMatrix();
    this.fpsCamera.aspect = window.innerWidth / window.innerHeight;
    this.fpsCamera.updateProjectionMatrix();
    this.renderer.setSize(window.innerWidth, window.innerHeight);
    this.resizeShaders();
  };

  // SET RESOLUTION:
  this.resMltV = 1;
  this.setResMlt = function (mlt) {
    this.resMltV = mlt;
    this.renderer.setPixelRatio(window.devicePixelRatio * this.resMltV);
    this.renderer.setSize(window.innerWidth, window.innerHeight);
  };

  // UPDATE FRUSTUM:
  this.updateFrustum = function () {
    this.frustum.setFromMatrix(tmpMatrix.multiplyMatrices(this.camera.projectionMatrix, this.camera.matrixWorldInverse));
  };

  // SCREENSHAKE:
  var shakeRadius = 0;
  var shakeAngle = 0;
  this.shakeX = 0;
  this.shakeY = 0;
  this.updateShake = function (delta) {
    if (shakeRadius) {
      shakeRadius *= Math.pow(0.99, delta);
      shakeAngle += UTILS.randFloat(-Math.PI, Math.PI);
      this.shakeX = Math.cos(shakeAngle) * shakeRadius;
      this.shakeY = Math.sin(shakeAngle) * shakeRadius;
      if (shakeRadius <= 0.01) {
        shakeRadius = 0;
        this.shakeX = this.shakeY = 0;
      }
    }
  };
  this.shake = function (val) {
    shakeRadius = val;
  };

  // RENDER:
  this.render = function (delta) {
    if (!this.scene) {
      return;
    }
    for (var i = 0; i < this.movTextures.length; ++i) {
      tmpObj = this.movTextures[i];
      if (tmpObj.tex.offset) {
        tmpObj.tex.offset[tmpObj.movD == 0 ? 'x' : 'y'] += tmpObj.mov * delta;
      }
    }
    if (this.postprocessing.enabled) {
      // window.effectComposer.render();
    } else {
      this.renderer.clear();
      this.camera.layers.set(0);
      if (this.skyDome) {
        // MOVE SKYDOME TO CAMERA:
        this.camera.getWorldPosition(this.skyDome.position);

        // RENDER BACKGROUND:
        this.renderer.render(this.backgroundScene, this.camera);
        this.renderer.clearDepth();
      }

      // RENDER SCENE:
      this.renderer.render(this.scene, this.camera);

      // RENDER ALWAYS VIS OBJECTS:
      this.camera.layers.set(2);
      this.renderer.clearDepth();
      this.renderer.render(this.scene, this.camera);

      // RENDER FPS GUN:
      this.renderer.clearDepth();
      this.renderer.render(this.scene, this.fpsCamera);
    }
    if (OVERLAY.showFlash) {
      if (flashTimer <= 0) {
        flashTimer = 0;
        OVERLAY.showFlash = false;
      }
      flashTimer -= delta;
    }
    this.updateShake(delta);
  };

  // UPDATE TEXTURE:
  this.updateTexture = function (src, img, data) {
    data = data || {};
    var cnt = 0;
    for (var index in textures) {
      if (index.substring(0, src.length) == src) {
        cnt++;
        textures[index].image = img;
        textures[index].needsUpdate = true;
      }
    }
    if (!cnt) {
      var tmpIndx = src + (data.movT != undefined ? data.movT : "mt") + (data.movD != undefined ? data.movD : "md");
      var tmpTex = textures[tmpIndx];
      tmpTex = new THREE.Texture(img);
      textures[tmpIndx] = tmpTex;
      textures[tmpIndx].needsUpdate = true;
    }
  };

  // LOAD TEXTURE:
  this.loadTexture = function (tmpMat, src, data, type) {
    data = data || {};
    var tmpIndx = src + (data.movT != undefined ? data.movT : "mt") + (data.movD != undefined ? data.movD : "md");
    if (!textures[tmpIndx]) {
      textures[tmpIndx] = {
        mats: [{
          t: type,
          m: tmpMat
        }]
      };
      textureLoader.load(UTILS.versionifyUrl("/textures/" + src + ".png"), texture => {
        texture.wrapS = THREE.RepeatWrapping;
        texture.wrapT = THREE.RepeatWrapping;
        texture.repeat.set(data.repeatX || 1, data.repeatY || 1);
        texture.minFilter = data.tFilter || THREE.NearestFilter;
        texture.magFilter = data.tFilter || THREE.NearestFilter;
        texture.needsUpdate = true;
        for (var i = 0; i < textures[tmpIndx].mats.length; ++i) {
          textures[tmpIndx].mats[i].m[textures[tmpIndx].mats[i].t || "map"] = texture;
          textures[tmpIndx].mats[i].m.needsUpdate = true;
        }
        textures[tmpIndx] = texture;
        if (data.movT) {
          this.movTextures.push({
            tex: texture,
            mov: data.movT,
            movD: data.movD || 0
          });
        }
      });
    } else {
      if (textures[tmpIndx].mats) {
        textures[tmpIndx].mats.push({
          t: type,
          m: tmpMat
        });
      } else {
        tmpMat[type || "map"] = textures[tmpIndx];
        tmpMat.needsUpdate = true;
      }
    }
    return tmpMat;
  };

  // GET MATERIAL:
  this.getMat = function (src, data) {
    var tmpIndx = (data ? data.texSrc || src : src) + (data ? (data.rotation || "x") + (data.noFog || "y") + (data.opacity || "z") + (data.color || "b") + (data.mat ? "ma" : "nm") + (data.ao || "a") + (data.emissive || "e") + (data.glowText || "g") + (data.movT != undefined ? data.movT : "mt") + (data.movD != undefined ? data.movD : "md") + (data.depthWrite != undefined ? data.depthWrite : "d") : "");
    var tmpMat = materials[tmpIndx];
    if (!tmpMat) {
      data = data || {};
      tmpMat = new (data.mat ? data.mat : THREE.StrippedLambertMaterial)(data);
      if (src && src != "default") {
        this.loadTexture(tmpMat, data.texSrc || src, data);
      }
      if (data && data.emissive) {
        this.loadTexture(tmpMat, (data.glowText ? data.texSrc || src : src) + (data.sameGlow ? "" : "_e"), data, "emissiveMap");
      }
      if (data && data.ao) {
        this.loadTexture(tmpMat, src + "_ao", data, "aoMap");
        tmpMat.aoMapIntensity = 1.3;
      }
      if (data && data.normal) {
        this.loadTexture(tmpMat, src + "_n", data, "normalMap");
      }
      if (src == "default") {
        tmpMat.vertexColors = THREE.VertexColors;
      }
      if (data && data.noFog) {
        tmpMat.fog = false;
      }
      tmpMat.shading = THREE.SmoothShading;
      materials[tmpIndx] = tmpMat;
    }
    return tmpMat;
  };

  // OFFSET MESH:
  this.offsetMesh = function (mesh, offset) {
    mesh.translateZ(offset);
  };

  // GEN COLOR CUBE:
  this.genColorCube = function (w, h, l, segments, offset, data) {
    data = data || {};
    var tmpIndex = data.us ? "us" : "ns";
    for (var i = 0; i < segments.length; ++i) {
      for (var x = 0; x < segments[i].length; ++x) {
        tmpIndex += segments[i][x] + "_";
      }
      tmpIndex += "|";
    }
    var tmpGeo = cubes[tmpIndex];
    if (!tmpGeo) {
      tmpGeo = new THREE.Geometry();
      var yOff = 0.5 + (offset || 0);
      for (var i = 0; i < segments.length; ++i) {
        var tmpH = segments[i][1];
        var tmpS = segments[i][2] || 1;
        var tmpMesh;
        if (!data.us) {
          var colGeo = new THREE.BoxGeometry(tmpS, tmpH, tmpS);
          GEOS.colorize(colGeo, segments[i][0]);
          tmpMesh = new THREE.Mesh(colGeo);
          this.moveMesh(tmpMesh, 0, yOff - tmpH / 2, 0);
        } else {
          var colGeo = GEOS.generateCube([1, 1, 1, 1, 1, 1], 1, 1, 1, {
            colr: segments[i][0],
            fAmb: segments[i][4],
            amb: segments[i][3]
          });
          tmpMesh = new THREE.Mesh(colGeo);
          tmpMesh.scale.set(tmpS, tmpH, tmpS);
          this.moveMesh(tmpMesh, 0, yOff - tmpH, 0);
        }
        this.merge(tmpGeo, tmpMesh);
        yOff -= tmpH;
      }
      cubes[tmpIndex] = tmpGeo;
    }
    var tmpMesh = new THREE.Mesh(tmpGeo, this.getMat("default"));
    this.scaleMesh(tmpMesh, w, h, l);
    return tmpMesh;
  };

  // GENERATE BODY:
  var bodyGeos = {};
  this.genBody = function (color, color2, color3, color4, det) {
    var tmpGeo = bodyGeos[color];
    if (!tmpGeo) {
      tmpGeo = new THREE.Geometry();
      var bH = config.playerHeight - config.headScale - config.legHeight;
      var body = this.genColorCube(config.chestWidth, bH, config.chestScale, [[color, 0.8, 1, 0.8], [color2, 0.2, 1.05]], 0, {
        us: det
      });
      this.moveMesh(body, 0, bH / 2, 0);
      this.merge(tmpGeo, body);
      var head = this.genColorCube(config.headScale, config.headScale, config.headScale, [[color3, 0.2, 1, 0.6], [color4, 0.8]], 0, {
        us: det
      });
      this.moveMesh(head, 0, config.playerHeight - config.headScale / 2 - config.legHeight, 0);
      this.merge(tmpGeo, head);
      tmpGeo = new THREE.BufferGeometry().fromGeometry(tmpGeo);
      bodyGeos[color] = tmpGeo;
    }
    var tmpMesh = new THREE.Mesh(tmpGeo, this.getMat("default"));
    tmpMesh.receiveShadow = true;
    tmpMesh.noGreen = true;
    return tmpMesh;
  };

  // GENERATE LEG:
  var legGeos = {};
  this.genLeg = function (left, color, color2, crouch, det) {
    var ls = config.legScale;
    var tmpGeo = null;
    if (crouch) {
      var tmpIndx = color + "-" + (crouch || "");
      tmpGeo = legGeos[tmpIndx];
      if (!tmpGeo) {
        var ll = config.legHeight / 2;
        var hs = ls / 2;
        var angles = [0.5, 2.0];
        var upper = this.genColorCube(ls, ll, ls, [[color, 1]], 0, {
          us: det
        });
        this.moveMesh(upper, 0, -(ll / 2 * Math.cos(angles[1])), -(ll / 2 * Math.sin(angles[1])));
        this.rotateMesh(upper, 0, angles[1], 0);
        var tmpD = Math.sqrt(hs * hs + hs * hs - 2 * hs * hs * Math.cos(angles[0] - angles[1]));
        var tmpL = Math.sqrt(hs * hs - tmpD / 2 * (tmpD / 2)) * 2;
        var connector = this.genColorCube(ls, tmpD, tmpL, [[color, 1]], 0, {
          us: det
        });
        this.moveMesh(connector, 0, -(ll * Math.cos(angles[1])), -(ll * Math.sin(angles[1])));
        this.rotateMesh(connector, 0, (angles[1] + angles[0]) / 2, 0);
        var lower = this.genColorCube(ls, ll, ls, [[color, 0.5, 1, 0.8], [color2, 0.5]], 0, {
          us: det
        });
        this.moveMesh(lower, 0, -ll * Math.cos(angles[1]) - ll / 2 * Math.cos(angles[0]), -ll * Math.sin(angles[1]) - ll / 2 * Math.sin(angles[0]));
        this.rotateMesh(lower, 0, angles[0], 0);
        var tmpGeo = new THREE.Geometry();
        this.merge(tmpGeo, upper);
        this.merge(tmpGeo, connector);
        this.merge(tmpGeo, lower);
        legGeos[tmpIndx] = tmpGeo;
      }
      tmpGeo = new THREE.BufferGeometry().fromGeometry(tmpGeo);
      tmpGeo = new THREE.Mesh(tmpGeo, this.getMat("default"));
      this.moveMesh(tmpGeo, config.legScale / 2 * (left ? -1 : 1), config.legHeight - config.crouchDst + 0.5, 0);
    } else {
      tmpGeo = this.genColorCube(ls, config.legHeight, ls, [[color, 0.75, 1], [color2, 0.25]], -0.5, {
        us: det
      });
      this.moveMesh(tmpGeo, config.legScale / 2 * (left ? -1 : 1), config.legHeight, 0);
    }
    tmpGeo.receiveShadow = true;
    tmpGeo.noGreen = true;
    return tmpGeo;
  };

  // GENERATE ARMS:
  var armGeos = {};
  this.genArms = function (weapon, color, color2, color3, sepIndex, isYou) {
    var tmpGeo = armGeos[weapon.name + "-" + color2 + "-" + isYou + "-" + (sepIndex || 0)];
    if (!tmpGeo) {
      tmpGeo = new THREE.Geometry();
      var armX = (-config.chestWidth + config.armScale / 2 - config.armInset) * (isYou ? weapon.holdW || 0.4 : 1);
      if (!sepIndex || sepIndex == 1) {
        this.merge(tmpGeo, this.genArm(armX, config.armOff, weapon, true, color, color2, color3, isYou));
      }
      if (!sepIndex || sepIndex == 2) {
        this.merge(tmpGeo, this.genArm(-armX, config.armOff, weapon, false, color, color2, color3, isYou));
      }
      tmpGeo = new THREE.BufferGeometry().fromGeometry(tmpGeo);
      armGeos[weapon.name + "-" + color2 + "-" + isYou + "-" + (sepIndex || 0)] = tmpGeo;
    }
    tmpGeo = new THREE.Mesh(tmpGeo, this.getMat("default"));
    tmpGeo.noGreen = true;
    tmpGeo.receiveShadow = true;
    return tmpGeo;
  };

  // GENERATE ARM:
  this.genArm = function (x, y, weapon, left, color, color2, color3, isYou) {
    var yOff = left ? weapon.leftHoldY : weapon.rightHoldY;
    var zOff = left ? weapon.leftHoldZ : weapon.rightHoldZ;
    var xOff = left ? weapon.leftHoldX || 0 : weapon.rightHoldX || 0;
    var armS = config.armScale * (isYou ? 0.7 : 1);
    var holdDist = Math.min(config.uArmLength + config.lArmLength - 0.01, UTILS.getDistance3D(x, y, 0, (weapon.xOff - xOff) * (left && weapon.akimbo ? -1 : 1), weapon.yOff + yOff, weapon.zOff - zOff));
    var angles = UTILS.getAnglesSSS(holdDist, config.uArmLength, config.lArmLength);
    var tmpAngle = Math.PI / 2;
    if (!isYou) {
      var upper = this.genColorCube(armS, config.uArmLength, armS, [[color, 1]], 0, {
        us: isYou
      });
      this.moveMesh(upper, 0, -(config.uArmLength / 2 * Math.cos(tmpAngle)), -(config.uArmLength / 2 * Math.sin(tmpAngle)));
      this.rotateMesh(upper, 0, tmpAngle, 0);
      var tmpS = armS / 2;
      var tmpD = Math.sqrt(tmpS * tmpS + tmpS * tmpS - 2 * tmpS * tmpS * Math.cos(Math.PI + angles[0] + Math.PI / 2));
      var tmpL = Math.sqrt(tmpS * tmpS - tmpD / 2 * (tmpD / 2)) * 2;
      var connector = this.genColorCube(armS, tmpD, tmpL, [[color, 1]], 0, {
        us: isYou
      });
      this.moveMesh(connector, 0, -(config.uArmLength * Math.cos(tmpAngle)), -(config.uArmLength * Math.sin(tmpAngle)));
      this.rotateMesh(connector, 0, (tmpAngle + angles[0]) / 2, 0);
    }
    var lower = this.genColorCube(armS, config.lArmLength, armS, [[color, 0.65, 1, 0.6], [color2, 0.15, 1.1], [color3, 0.2, 1, 0.5, true]], 0, {
      us: isYou
    });
    var tOff = config.lArmLength / 2;
    this.moveMesh(lower, 0, -config.uArmLength * Math.cos(tmpAngle) - tOff * Math.cos(angles[0]), -config.uArmLength * Math.sin(tmpAngle) - tOff * Math.sin(angles[0]));
    this.rotateMesh(lower, 0, angles[0], 0);
    var tmpObj = new THREE.Geometry();
    if (!isYou) {
      this.merge(tmpObj, upper);
      this.merge(tmpObj, connector);
    } else {
      var extender = this.genColorCube(armS, 20, armS, [[color, 1]], 0, {
        us: isYou
      });
      this.moveMesh(extender, 0, -config.uArmLength * Math.cos(tmpAngle) - -10 * Math.cos(angles[0]), -config.uArmLength * Math.sin(tmpAngle) - -10 * Math.sin(angles[0]));
      this.rotateMesh(extender, 0, angles[0], 0);
      this.merge(tmpObj, extender);
    }
    this.merge(tmpObj, lower);
    tmpObj = new THREE.Mesh(tmpObj);
    this.moveMesh(tmpObj, x - weapon.xOff, y - weapon.yOff, -weapon.zOff);
    tmpObj.rotation.order = "YXZ";
    tmpObj.rotation.x = -angles[1] - UTILS.getDirection(0, y, weapon.zOff - zOff, weapon.yOff + yOff);
    tmpObj.rotation.y = UTILS.getDirection(-x, 0, (left && weapon.akimbo ? 1 : -1) * (weapon.xOff - xOff), weapon.zOff - zOff) - Math.PI / 2;
    return tmpObj;
  };

  // ADD CUBE:
  this.addCube = function (x, y, z, w, h, l, sides, data) {
    data = data || {};
    var mesh = new THREE.Mesh(GEOS.generateCube(sides, w, h, l, data));
    this.moveMesh(mesh, x, y, z);
    mesh.rotation.set(data.yR || 0, data.xR || 0, data.zR || 0);
    mesh.scale.set(w, h, l);
    if (data.src && !data.noGroup) {
      this.meshGroup(mesh, data);
    } else {
      this.add(mesh, data);
    }
    return mesh;
  };

  // ADD SPRAY:
  var sprays = [];
  this.addSpray = function (sid, index, x, y, z, xD, yD, opacity) {
    tmpObj = null;
    for (var i = 0; i < sprays.length; ++i) {
      if (sprays[i].sid == sid) {
        tmpObj = sprays[i];
        break;
      }
    }
    if (!tmpObj) {
      tmpObj = new THREE.Mesh(planeGeo);
      tmpObj.sid = sid;
      tmpObj.scale.set(config.sprayScale, config.sprayScale, 1);
      tmpObj.receiveShadow = true;
      sprays.push(tmpObj);
      this.add(tmpObj);
    }
    this.moveMesh(tmpObj, x, y, z);
    tmpObj.rotation.y = UTILS.toRad(xD);
    tmpObj.rotation.x = UTILS.toRad(yD);
    tmpObj.material = this.getMat("sprays/" + index, {
      depthWrite: false,
      opacity: opacity,
      transparent: true
    });
  };
  this.clearSprays = function () {
    for (var i = 0; i < sprays.length; ++i) {
      if (sprays[i] && sprays[i].material.map) {
        sprays[i].material.map.dispose();
      }
      this.scene.remove(sprays[i]);
    }
    sprays.length = 0;
  };

  // ADD PLANE:
  this.addPlane = function (x, y, z, w, l, data, xR, yR, zR) {
    data = data || {};
    data.premultipliedAlpha = true;
    var mesh = new THREE.Mesh(GEOS.generatePlane(l, w, data, x, y, z));
    if (data.euler) {
      mesh.rotation.order = data.euler;
    }
    this.moveMesh(mesh, x, y, z);
    mesh.rotateY(xR || 0);
    mesh.rotateX((yR || 0) - Math.PI / 2);
    mesh.rotateZ(zR || 0);
    mesh.scale.set(w * 2, l * 2, 1);
    if (!data.dontAdd) {
      if (data.src && !data.noGroup) {
        this.meshGroup(mesh, data, 1);
      } else {
        this.add(mesh, data);
      }
    } else {
      if (data.src) {
        mesh.material = this.getMat(data.src, data);
      }
    }
    return mesh;
  };

  // ADD RAMP:
  this.addRamp = function (x, y, z, w, h, l, dir, data, zD) {
    data = data || {};
    var mesh = new THREE.Mesh(GEOS.generatePlane(l * 2, w, data));
    this.moveMesh(mesh, x, y + h / 2, z);
    l *= 2;
    var rl = Math.sqrt(h * h + l * l);
    mesh.scale.set(w, rl, 2);
    mesh.rotateY(-(Math.PI / 2) - dir);
    mesh.rotateX(Math.asin(h / rl) - Math.PI / 2);
    mesh.rotateZ(zD || 0);
    if (data.src) {
      this.meshGroup(mesh, data, 1);
    } else {
      this.add(mesh, data);
    }
    return mesh;
  };

  // ADD GRASS:
  this.addGrass = function (x, y, z, w, h, l, data) {
    data = data || {};
    let tmpGeo = new THREE.Geometry();
    let angle = Math.PI * 2 * Math.random();
    let tmpMesh = new THREE.Mesh(GEOS.generatePlane(w, h, data));
    tmpMesh.rotateY(angle * (Math.PI / 2));
    this.merge(tmpGeo, tmpMesh);
    let tmpMesh2 = new THREE.Mesh(GEOS.generatePlane(w, h, data));
    tmpMesh2.rotateY((angle + 1) * (Math.PI / 2));
    this.merge(tmpGeo, tmpMesh2);
    let mesh = new THREE.Mesh(tmpGeo);
    this.moveMesh(mesh, x, y + h / 2, z);
    mesh.rotation.set(data.yR || 0, data.xR || 0, data.zR || 0);
    mesh.scale.set(w, h, l);
    if (data.src && !data.noGroup) {
      this.meshGroup(mesh, data);
    } else {
      this.add(mesh, data);
    }
    return mesh;
  };

  // LOAD MESH:
  var loadedGeos = [];
  var pendingMeshes = [];
  this.loadMesh = function (data, x, y, z, r, scale, obj, merge) {
    var tmpMat = this.getMat(data.src, data);
    var tmpGeo = loadedGeos[data.src];
    if (!tmpGeo) {
      tmpGeo = merge ? new THREE.Geometry() : new THREE.BufferGeometry();
      loadedGeos[data.src] = tmpGeo;
      objLoader.load(UTILS.versionifyUrl("/models/" + data.src + ".obj"), function (mesh) {
        tmpGeo.copy(merge ? new THREE.Geometry().fromBufferGeometry(mesh.children[0].geometry) : mesh.children[0].geometry);
        if (data.uv2) {
          tmpGeo.addAttribute('uv2', new THREE.BufferAttribute(tmpGeo.attributes.uv.array, 2));
        }
        if (merge) {
          var addGeo = new THREE.Geometry();
          for (var i = 0; i < pendingMeshes[data.src].length; ++i) {
            context.merge(addGeo, pendingMeshes[data.src][i]);
          }
          context.add(new THREE.Mesh(new THREE.BufferGeometry().fromGeometry(addGeo), tmpMat), data);
          pendingMeshes[data.src].length = 0;
          pendingMeshes[data.src].loaded = true;
        }
        if (data.centerZ) {
          tmpGeo.computeBoundingBox();
          var center = tmpGeo.boundingBox.getCenter();
          obj.translateZ(center.x * scale);
        }
      });
    } else {
      if (data.centerZ) {
        tmpGeo.computeBoundingBox();
        var center = tmpGeo.boundingBox.getCenter();
        obj.translateZ(center.x * scale);
      }
    }
    var tmpMesh = new THREE.Mesh(tmpGeo, tmpMat);
    tmpMesh.receiveShadow = data.noShadow ? false : true;
    tmpMesh.noGreen = data.noGreen;
    tmpMesh.castShadow = data.shadows;
    if (typeof r == 'object') {
      tmpMesh.rotation.x = tmpMesh.xR = r[0] || 0;
      tmpMesh.rotation.y = tmpMesh.yR = r[1] || 0;
      tmpMesh.rotation.z = tmpMesh.zR = r[2] || 0;
    } else {
      tmpMesh.rotation.y = r || 0;
    }
    tmpMesh.xP = x;
    tmpMesh.yP = y;
    tmpMesh.zP = z;
    context.moveMesh(tmpMesh, x, y, z);
    context.scaleMesh(tmpMesh, scale || 1, scale || 1, scale || 1);
    if (merge) {
      if (!pendingMeshes[data.src]) {
        pendingMeshes[data.src] = [tmpMesh];
      } else {
        if (pendingMeshes[data.src].loaded) {
          this.meshGroup(tmpMesh, data);
        } else {
          pendingMeshes[data.src].push(tmpMesh);
        }
      }
    } else {
      obj.add(tmpMesh);
    }
    return tmpMesh;
  };

  // CLEAR PENDING MESHES:
  this.clearPendingMeshes = function () {
    for (var msh in pendingMeshes) {
      if (pendingMeshes.hasOwnProperty(msh) && pendingMeshes[msh]) {
        pendingMeshes[msh].length = 0;
      }
    }
  };

  // UPDATE MESH:
  this.updateMesh = function (src, text) {
    var mesh = objLoader.parse(text);
    var tmpGeo = new THREE.BufferGeometry();
    loadedGeos[src] = tmpGeo;
    // mesh.children[0].geometry.computeVertexNormals();
    tmpGeo.copy(mesh.children[0].geometry);
    tmpGeo.needsUpdate = true;
  };

  // GENERATE GROUP:
  this.genObj3D = function (x, y, z) {
    var obj3D = new THREE.Object3D();
    this.moveMesh(obj3D, x || 0, y || 0, z || 0);
    return obj3D;
  };

  // MERGE:
  this.merge = function (parent, child, index) {
    child.updateMatrix();
    parent.merge(child.geometry, child.matrix, index);
  };

  // ADD MESH TO GROUP:
  this.meshGroup = function (mesh, data) {
    var tmpIndx = data.src + "-" + (data.shadowsR || "a") + (data.emissive || "e") + (data.opacity || "o") + (data.movT != undefined ? data.movT : "mt") + (data.movD != undefined ? data.movD : "md");
    if (!groupMeshes[tmpIndx]) {
      groupMeshes[tmpIndx] = new THREE.Geometry();
      groupMeshes[tmpIndx].data = data;
    }
    mesh.updateMatrix();
    groupMeshes[tmpIndx].merge(mesh.geometry, mesh.matrix);
  };

  // ADD MESH GROUPS:
  this.addMeshGroups = function () {
    for (var mesh in groupMeshes) {
      if (groupMeshes.hasOwnProperty(mesh)) {
        var tmpMesh = new THREE.Mesh(new THREE.BufferGeometry().fromGeometry(groupMeshes[mesh]));
        tmpMesh.groupSrc = groupMeshes[mesh].data.src;
        tmpMesh.visible = meshVisibilities[tmpMesh.groupSrc] ? false : true;
        tmpMesh.matrixAutoUpdate = false;
        this.add(tmpMesh, groupMeshes[mesh].data);
      }
    }
    groupMeshes = {};
  };

  // TOGGLE MESH GROUP:
  var meshVisibilities = {};
  this.toggleMeshGroup = function (src, vis) {
    meshVisibilities[src] = !vis;
    if (this.scene) {
      this.scene.traverse(function (node) {
        if (node instanceof THREE.Mesh && node.groupSrc == src) {
          node.visible = vis;
        }
      });
    }
  };

  // ADD MESHES TO SCENE:
  this.add = function (mesh, data) {
    if (data) {
      mesh.castShadow = data.shadows;
      mesh.receiveShadow = data.shadows || data.shadowsR;
      mesh.material = this.getMat(data.src, data);
    }
    this.updateGreenScreen(mesh);
    this.scene.add(mesh);
    this.updateShadowMap();
  };

  // REMOVE MESHES FROM SCENE:
  this.remove = function (meshes) {
    this.scene.remove(meshes);
    // TODO: DISPOSE MATERIAL OF ALL CHILDREN
    // DISPOSE GEOMETRY OF ALL CHILDREN
  };

  // MOVE MESH:
  this.moveMesh = function (mesh, x, y, z) {
    if (x != undefined) {
      mesh.position.x = x;
    }
    if (y != undefined) {
      mesh.position.y = y;
    }
    if (z != undefined) {
      mesh.position.z = z;
    }
  };

  // SCALE MESH:
  this.scaleMesh = function (mesh, x, y, z) {
    mesh.scale.set(x, y, z);
  };

  // ROTATE MESH:
  this.rotateMesh = function (mesh, x, y, z) {
    if (x || x == 0) {
      mesh.rotation.y = x;
    }
    if (y || y == 0) {
      mesh.rotation.x = y;
    }
    if (z || z == 0) {
      mesh.rotation.z = z;
    }
  };

  // CLEAR RENDER:
  this.reset = function () {
    loadedGeos = [];
    pendingMeshes = [];
    groupMeshes = {};
    materials = {};
    textures = {};
    this.movTextures = [];
  };
};

// EFFECT INITIATOR:
module.exports.initScene = function (map) {
  mapData = map;
  if (map.ambient) {
    this.ambientLight = new THREE.AmbientLight(map.ambient);
    this.ambientLight.layers.enable(1);
    this.ambientLight.layers.enable(2);
    this.ambientLight.name = "ambLight";
    if (!this.scene.getObjectByName('ambLight')) {
      this.scene.add(this.ambientLight);
    }
  }
  if (map.light) {
    this.skyLight = new THREE.DirectionalLight(map.light, 1.3);
    this.skyLight.name = "skyLight";
    this.skyLight.layers.enable(1);
    this.skyLight.layers.enable(2);
    if (!this.scene.getObjectByName('skyLight')) {
      this.scene.add(this.skyLight);
    }
    var theta = Math.PI * (0.2 - 0.5);
    var phi = 2 * Math.PI * (0.25 - 0.5);
    this.skyLight.position.x = config.lightDistance * Math.cos(phi);
    this.skyLight.position.y = config.lightDistance * Math.sin(phi) * Math.sin(theta);
    this.skyLight.position.z = config.lightDistance * Math.sin(phi) * Math.cos(theta);
    this.skyLight.castShadow = true;
    this.skyLight.shadow.mapSize.width = map.shadowR || config.shadowRes;
    this.skyLight.shadow.mapSize.height = map.shadowR || config.shadowRes;
    this.skyLight.shadow.camera.far = config.shadowDst;
  }
  this.scene.fog = new THREE.Fog(map.fog, 1, map.fogD);
  this.renderer.setClearColor(map.sky);
  if (this.useDepthMap && this.useDepthMap != "0") {
    this.toggleDepthMap(this.useDepthMap);
  }
  if (this.greenScreen) {
    this.toggleGreenscreen(this.greenScreen);
  }
};